// npm
import ky from 'ky' // https://github.com/sindresorhus/ky

export async function getAccount() {
  return ky.get('/api/account').json()
}

export async function getDomains() {
  return ky.get(`/api/domain/`).json()
}

export async function getItems(domainName) {
  console.log('getItems() - domainName:', domainName)
  const opts = {
    searchParams: {
      domainName,
    }
  }
  return ky.get(`/api/item/`, opts).json()
}
